import React, { useEffect } from 'react';
import { useDispatch } from 'redux-react-hook';
import _delay from 'lodash/delay';
import { STRINGS } from 'config';
import styled from 'styled-components';
import { Div } from 'styles/elements/div';
import { fadeInAndOut } from 'styles/animations';
import { clearValidationMessage } from 'redux/actions/session';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';

const { PRODUCT: { E_TRIAGE } } = STRINGS;

const ANIMATION_TIME = 10; // seconds

const SuccessBanner = styled(Div)`
  background-color: green;
  position: absolute;
  z-index: 1;
  align-self: center;
  width: 70%;
  color: white;
  padding: 15px;
  justify-content: center;
  text-align: center;
  border-radius: 0 0 20px 20px;
  font-size: 24px;
  font-weight: bold;
  opacity: 0;
  animation: ${fadeInAndOut} ${ANIMATION_TIME}s linear forwards;
`;

function Message({ validationMessages }) {
  const dispatch = useDispatch();
  useEffect(() => {
    _delay(() => dispatch(clearValidationMessage()), (ANIMATION_TIME * 1000));
  }, [dispatch]);
  return _map(validationMessages, (validation, i) => <SuccessBanner key={`validationMessage-${i}`}>{validation.message}</SuccessBanner>);
}

export const ValidationMessages = ({ product, validationMessages }) => {
  if (product !== E_TRIAGE || _isEmpty(validationMessages)) {
    return null;
  }
  return <Message validationMessages={validationMessages} />;
};
